module.exports = __webpack_public_path__ + "static/media/28DGC1.b133705d.jpg";